import Item from "./Item";
import Benefits from "../../components/Benefits";
import {
    INDOOR_SECURITY_CAMERAS,
    OTHER,
    OUTDOOR_SECURITY_CAMERAS,
} from "../../products";
import { useCart } from "../../contexts/Cart";
import { useTranslation } from "react-i18next";
// import AnnouncementModal from "../../components/AnnouncementModal";
// import Subscribe from "../../components/Subscribe";
// import FAQSection from "./FAQ";

export default function Home() {
    const { addToCart } = useCart();
    const { t } = useTranslation();

    return (
        <>
            {/* <AnnouncementModal /> */}

            <Benefits />

            <Item
                title={t("home.indoor-security-cameras")}
                products={INDOOR_SECURITY_CAMERAS}
                addToCart={addToCart}
            />

            <Item
                title={t("home.outdoor-security-cameras")}
                products={OUTDOOR_SECURITY_CAMERAS}
                addToCart={addToCart}
                solar
            />

            <Item title={t("home.other-products")} products={OTHER} addToCart={addToCart} />

            {/* <Subscribe /> */}

            {/* FAQ */}
            {/* <FAQSection /> */}

            {/* <Row>
                    Some testimonials (რეკომენდატორები) https://testimonial.to/
                </Row> */}

            {/* <FeaturedIn title={t("home.featured-in")} /> */}
        </>
    );
}